/**
 * @description 圖片轉換網址
 * @param {string} imgUrl 網址
 * @param {string} sizeStr 尺寸
 */
function imgTransfer(imgUrl, sizeStr) {
  if (imgUrl == null || imgUrl.length === 0) return null;

  const imgName = imgUrl.substring(imgUrl.lastIndexOf('/') + 1, imgUrl.length - 4);
  const imgExtension = imgUrl.substring(imgUrl.length - 4, imgUrl.length);
  const splitArr = imgUrl.split('/');
  const folderName = splitArr[4];
  const pictureContainer = splitArr[3];

  // gif不近縮圖
  if (imgUrl.indexOf('gif') !== -1) {
    return `https://${window.StaticImgDomain}/${pictureContainer}/${folderName}s/${imgName}${imgExtension}`;
  }
  if (imgUrl.indexOf('.mp4') !== -1) {
    if (imgUrl.indexOf('pics') === -1 && imgUrl.indexOf('pic') !== -1) {
      return imgUrl.replace('pic', 'pics');
    }
    return imgUrl;
  }
  return `https://${window.StaticImgDomain}/${pictureContainer}/${folderName}s/${imgName}${sizeStr}${imgExtension}`;
}

function useImage() {
  return { imgTransfer };
}

export default useImage;
